/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Convert_Page_ErrorInputs */

const en_common_convert_page_error = /** @type {(inputs: Common_Convert_Page_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to convert the page. Please try later or contact support center.`)
};

const es_common_convert_page_error = /** @type {(inputs: Common_Convert_Page_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo convertir la página. Inténtalo más tarde o contacta soporte.`)
};

/**
* | output |
* | --- |
* | "Failed to convert the page. Please try later or contact support center." |
*
* @param {Common_Convert_Page_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_convert_page_error = /** @type {((inputs?: Common_Convert_Page_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Convert_Page_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_convert_page_error(inputs)
	return en_common_convert_page_error(inputs)
});